import TreeNodeType from '../../constants/liquidation/TreeNodeType';
import type SensOptions from '../../interfaces/pieces/bordereaux/SensOptions';
import { SENS_TOUS } from '../../interfaces/pieces/bordereaux/SensOptions';
import type { TreeRow } from '../../interfaces/pieces/TreeRow';

/**
 * Filtres de la treeview (état du bordereau, sens), appliqués aux enfants des entités pendant la construction de
 * l'arbre affiché (TreeIndex.buildVisibleTree) : les entités restent, même sans bordereau correspondant, et les
 * pièces d'un bordereau affiché ne sont pas filtrées.
 */
class TreeRowFilter {
	private bordereauState: number | null = null;

	private sens: SensOptions = SENS_TOUS;

	constructor(bordereauState: number | null, sens: SensOptions) {
		this.bordereauState = bordereauState;
		this.sens = sens;
	}

	get isActive(): boolean {
		return Boolean(this.bordereauState) || this.sens !== SENS_TOUS;
	}

	/**
	 * Vrai si la ligne passe les filtres. Une entité passe toujours ; avec un filtre d'état, seuls les bordereaux
	 * de cet état passent (pas les bordereaux de travail à créer) ; avec un filtre de sens, seuls les bordereaux
	 * et bordereaux de travail de ce sens.
	 */
	accepts(row: TreeRow): boolean {
		if (row.nodeType === TreeNodeType.ENTITE) {
			return true;
		}

		if (
			this.bordereauState &&
			!(
				row.nodeType === TreeNodeType.BORDEREAU &&
				row.bordereau?.state?.step === this.bordereauState
			)
		) {
			return false;
		}

		if (this.sens !== SENS_TOUS) {
			const isBordereau =
				row.nodeType === TreeNodeType.BORDEREAU ||
				row.nodeType === TreeNodeType.CREATE_BORDEREAU;
			return isBordereau && row.bordereau?.sens === this.sens;
		}

		return true;
	}

	/** Filtre des enfants affichés, pour TreeIndex.buildVisibleTree : seuls les enfants d'une entité sont filtrés. */
	acceptChild = (parent: TreeRow, child: TreeRow): boolean =>
		parent.nodeType !== TreeNodeType.ENTITE || this.accepts(child);
}

export default TreeRowFilter;
